// Created by hejikun on 2017/11/2 0002.
let accompany = [
  {
    path: '/accompany',
    name: '陪诊预约',
    component: () => import('@/pages/accompany/index')
  },
  {
    path: '/accompany/detail',
    name: '陪诊详情',
    component: () => import('@/pages/accompany/detail')
  },
  {
    path: '/accompany/introduce',
    name: '门诊陪诊服务介绍',
    component: () => import('@/pages/accompany/introduce')
  },
  {
    path: '/accompany/service_form',
    name: '门诊陪诊服务资料填写',
    component: () => import('@/pages/accompany/service_form'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/accompany/result',
    name: '记录详情',
    component: () => import('@/pages/accompany/result')
  },
  {
    path: '/accompany/examineList',
    name: '单项陪诊服务',
    component: () => import('@/pages/accompany/examineList')
  },
  {
    path: '/accompany/examine_form',
    name: '单项陪诊服务资料填写',
    component: () => import('@/pages/accompany/examine_form')
  },
  {
    path: '/accompany/report_mail',
    name: '代取报告资料填写',
    component: () => import('@/pages/accompany/report_mail')
  },
  {
    path: '/accompany/hos_index',
    name: '医院陪诊首页',
    component: () => import('@/pages/accompany/hos_index')
  },
  {
    path: '/accompany/order_list',
    name: '挂号列表',
    component: () => import('@/pages/accompany/order_list')
  },
  {
    path: '/accompany/accompany_order_list',
    name: '订单列表',
    component: () => import('@/pages/accompany/accompany_order_list')
  },
  {
    path: '/accompany/workList',
    name: '预约人陪诊信息列表',
    component: () => import('@/pages/accompany/workList')
  },
  {
    path: '/accompany/workListDetail',
    name: '预约人陪诊信息详情',
    component: () => import('@/pages/accompany/workListDetail')
  }
]

export default accompany
